angular.module('rjmNg.controllers').controller('renameDashCtrl', [
  "$scope"
  "$modal"
  "dashboardService"
  ($scope, $modal, dashboardService) ->

    $scope.error = null
    $scope.name = $scope.name

    $scope.renameDashboard = (modal) ->
      if $scope.name?.length <= 0 # do not allow empty names
        $scope.error = "Name must contain at least one character"
        return
      if $scope.name?.length > 64 # match Shared Dashboard.php MAX_NAME_LENGTH
        $scope.error = "Please choose a shorter name. Name cannot be more than 64 characters"
        return

      $scope.dashboard.name = $scope.name

      onSuccess = (result) ->
        dashboardService.updateGlobalSearch()
        modal('hide')

      onError = (data) ->
        $scope.error = data.error

      dashboardService.save($scope.dashboard).then(onSuccess, onError)
  ]
)
